import useSWRFetcher from "../commonly-stored/fetcher";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { Footprint } from "./models";

export default function useFootprintForPart(partId: string | null) {
  const fetcher = useSWRFetcher<Footprint | null>();

  const { data, mutate, isLoading } = useSWR<Footprint | null>(
    partId !== null ? `${settings.api_url}/parts/${partId}/footprint` : null,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return {
    footprint: data || null,
    refreshFootprint: () => void mutate(),
    loading: isLoading,
  };
}
